import request from '@wearetla/tla-essentials-tools/utilities/request';

import config from '@wearetla/tla-essentials-tools/config';
import { createI18nInstance } from '/utilities/i18n';

const getT = () => createI18nInstance().t;

// Dummy içerikteki çok dilli alanları ({ tr, en }) aktif dile göre seçer, yoksa Türkçe'ye düşer.
// Gerçek API metinleri `language` başlığına göre çevrilmiş döndüreceği için bu yalnızca dummy veri içindir.
const localize = (value) => {
	if (!value || typeof value !== 'object') {
		return value ?? null;
	}

	const language = (createI18nInstance().language ?? 'tr').split('-')[0].toLowerCase();

	return value[language] ?? value.tr ?? null;
};

const parsePromotionCta = (cta) =>
	cta
		? {
				...cta,
				title: localize(cta.title),
			}
		: null;

const parsePromotion = (promotion) => ({
	...promotion,
	title: localize(promotion.title),
	description: localize(promotion.description),
	descriptionLoggedIn: localize(promotion.descriptionLoggedIn),
	cta: promotion.cta
		? {
				guest: parsePromotionCta(promotion.cta.guest),
				loggedIn: parsePromotionCta(promotion.cta.loggedIn),
			}
		: null,
});

const siteServices = {
	checkAppUpdates: () => {
		return new Promise((resolve, reject) => {
			request.get(
				'get-build-number',
				false,
				(payload) => {
					if (payload?.length) {
						resolve(config.buildNumber !== payload);
					} else {
						reject(payload);
					}
				},
				{ static: true, external: true }
			);
		});
	},
	getBanners: (branchId) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(
				`client/${config.clientId}/branch/${branchId}/banners`,
				{},
				(payload, status, request) => {
					if (payload?.client_branch_banners?.length) {
						resolve(payload.client_branch_banners);
					} else {
						reject(
							request?.data?.meta?.messages || t('Bannerlar getirilirken bir hata ile karşılaşıldı.')
						);
					}
				}
			);
		});
	},
	getHighlightedProducts: () => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(
				`dummy/api/home-highlighted-products.json`,
				{},
				(payload, status, request) => {
					if (payload?.products?.length) {
						resolve(payload.products);
					} else {
						reject(
							request?.data?.meta?.messages || t('Ürünler getirilirken bir hata ile karşılaşıldı.')
						);
					}
				},
				{ static: true }
			);
		});
	},
	getPromotions: () => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(
				`dummy/api/promotions.json`,
				{},
				(payload, status, request) => {
					if (payload?.promotions) {
						resolve(payload.promotions.map(parsePromotion));
					} else {
						reject(
							request?.data?.meta?.messages || t('Ürünler getirilirken bir hata ile karşılaşıldı.')
						);
					}
				},
				{ static: true }
			);
		});
	},
};

export default siteServices;
